import React, { useEffect, useRef } from "react";
import { Button, Layout } from "antd";
import "./style.scss";
import gjuLogo from "../assets/images/logo1.png";
import smartLab from "../assets/images/smart-lab-white.png";
import { Routes, Route, useNavigate, Outlet, Navigate } from "react-router-dom";
import Landing from "../pages/Landing";
import Login from "../pages/Login";
import { useSelector } from "react-redux";
import { Toast } from "primereact/toast";
import { ProgressBar } from "primereact/progressbar";
import { useDispatch } from "react-redux";

import { TabMenu } from "primereact/tabmenu";
import Home from "../pages/Home";
import About from "../pages/About";
import AppLayout from "./Applayout";
import MyRequests from "../pages/MyRequests";
import Profile from "../pages/Profile";
import { logout } from "../redux/action";
import Footer from "./Footer";
import Users from "../pages/Users";
import Transactions from "../pages/Transactions";
import Courses from "../pages/Courses";

const { Header, Content } = Layout;

const PrivateRoute = () => {
  const isLoggedIn = useSelector((state) => state.redux.isLoggedIn);
  return isLoggedIn ? <Outlet /> : <Navigate to={"/"} />;
};

const ApplicationLayout = (props) => {
  const toast = useRef(null);
  const { errorMessage, isLoggedIn, loading, successMessage } = useSelector(
    (state) => state.redux
  );
  const userInfo = useSelector((state) => state.redux.userInfo);

  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    if (errorMessage) {
      toast.current.show({
        severity: "error",
        summary: "Error Message",
        detail: errorMessage,
        life: 3000,
      });
    }
    if (successMessage) {
      toast.current.show({
        severity: "success",
        summary: "Success Message",
        detail: successMessage,
        life: 3000,
      });
    }
  }, [errorMessage, successMessage]);

  const getActiveIndex = () => {
    const url = window.location.href;
    if (url.indexOf("/about") !== -1) {
      return 1;
    }
    if (url.indexOf("/home") !== -1) {
      return 2;
    }
    return 0;
  };

  const items = [
    {
      label: "Landing",
      key: 1,
      show: true,
      className:
        window.location.href.indexOf("/about") === -1 &&
        window.location.href.indexOf("/home") === -1 && 
        window.location.href.indexOf("/courses") === -1
          ? "active"
          : "",
      command: (e) => {
        navigate("/");
      },
    },
    {
      label: "About Project",
      key: 2,
      show: true,
      className: window.location.href.indexOf("/about") !== -1 ? "active" : "",

      command: (e) => {
        navigate("/about");
      },
    },
    {
      label: "Courses",
      key: 3,
      show: true,
      className: window.location.href.indexOf("/courses") !== -1 ? "active" : "",
      command: (e) => {
        navigate("/courses");
      },
    },
    {
      label: "Home",
      key: 4,
      show: isLoggedIn,
      className: window.location.href.indexOf("/home") !== -1 ? "active" : "",
      command: (e) => {
        userInfo.isAdmin ? navigate("/home/users"): navigate("/home");
      },
    },
  ];

  const getItems = () => {
    return items.filter((item) => item.show);
  };

  return (
    <Layout className="layout">
      <Toast ref={toast} />
      {loading && (
        <>
          <div className="loader-overlay"></div>
          <ProgressBar
            mode="indeterminate"
            color={"#dd2b68"}
            style={{ height: "6px" }}
          ></ProgressBar>
        </>
      )}
      <Header className="d-flex  justify-content-between">
        <div className="logo">
          <img alt="smartLab" className="mx-2" src={smartLab} width="100" />
          <img alt="gju" src={gjuLogo} width="75" />
        </div>
        <div className="d-flex flex-column align-items-center justify-content-between">
          <h4 className="text-white mt-3 mb-0">P2P Electricity Trading</h4>
        <TabMenu
          activeIndex={getActiveIndex()}
          // onTabChange={(item) => navigate(item.value.link)}
          className="navigations d-flex"
          model={getItems()}
        />
        </div>

        <div className="mt-auto">
          {isLoggedIn ? (
            <Button
              onClick={() => dispatch(logout())}
              className="login-btn"
              type="primary"
            >
              Logout
            </Button>
          ) : (
            <Button
              onClick={() => navigate("/login")}
              className="login-btn"
              type="primary"
            >
              Login
            </Button>
          )}
        </div>
      </Header>
      <Content>
        <div className="page-content">
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route
              path="/login"
              element={isLoggedIn ? <Navigate to="/home" /> : <Login />}
            />
            <Route path="/about" element={<About />} />
            <Route path="/courses" element={<Courses/>} />

            <Route path="/home" element={<PrivateRoute />}>
              <Route path="/home" element={<AppLayout />}>
                <Route path="/home/" element={<Home />} />
                <Route path="/home/profile" element={<Profile />} />
                <Route path="/home/transactions" element={<Transactions />} />
                <Route path="/home/trading" element={<Home />} />
                <Route path="/home/my-requests" element={<MyRequests />} />
                <Route path="/home/users" element={<Users />} />
              </Route>
            </Route>
          </Routes>
        </div>
      </Content>
      <Footer/>
    </Layout>
  );
};

export default ApplicationLayout;
